import {
  getUserRecommendations,
  getGenericRecommendations
} from 'shared/models/api';

export const USER_RECOMMENDATIONS_LOADING = 'USER_RECOMMENDATIONS_LOADING';
export const USER_RECOMMENDATIONS_ERROR = 'USER_RECOMMENDATIONS_ERROR';
export const USER_RECOMMENDATIONS = 'USER_RECOMMENDATIONS';

const initialState = {
  userRecommendations: [],
  loadingUserRecommendations: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_RECOMMENDATIONS_LOADING:
      return { ...state, loadingUserRecommendations: true };
    case USER_RECOMMENDATIONS_ERROR:
      return { ...state, loadingUserRecommendations: false };
    case USER_RECOMMENDATIONS:
      return {
        ...state,
        userRecommendations: action.recommendations,
        loadingUserRecommendations: false
      };
    default:
      return state;
  }
}

export function loadUserRecommendations() {
  return (dispatch, getState) => {
    const user = getState().login.user;
    const req = user
      ? getUserRecommendations(user)
      : getGenericRecommendations();

    dispatch({ type: USER_RECOMMENDATIONS_LOADING });

    return req
      .then(recommendations =>
        dispatch({ type: USER_RECOMMENDATIONS, recommendations })
      )
      .catch(() => dispatch({ type: USER_RECOMMENDATIONS_ERROR }));
  };
}
